module.exports = __webpack_public_path__ + "img/logo-komship-by-komerce.2448c6d6.svg";